import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../cache/CacheKeys'
import CacheManager from '../../cache/CacheManager'
import RestApiUtils from "../../apiclient/moebli/RestApiUtils"
import ZTransactionListPageUI from './ZTransactionListPageUI.js'
import LocalStorageKeys from '../../cache/LocalStorageKeys'

class ZTransactionListPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: null,
      txnList: null,
      filteredTxnList: null,
      bankAccountList: null,
      searchFilter: '',
      currentPage: 0,
      hasMore: true,
      gettingMore: false,
      downloadMode: false
    }
  }

  render() {
    return (
      <ZTransactionListPageUI
        context={this.props.context}
        errorList={this.state.errorList}
        txnList={this.state.txnList}
        filteredTxnList={this.state.filteredTxnList}
        bankAccountList={this.state.bankAccountList}
        onRefreshClick={this.onRefreshClick}
        searchFilter={this.state.searchFilter}
        onSearchFilterChange={this.onSearchFilterChange}
        // pagination
        hasMore={this.state.hasMore}
        onMoreTransactions={this.onMoreTransactions}
        gettingMore={this.state.gettingMore}
        // Download
        downloadMode={this.state.downloadMode}
        onDownloadClick={this.onDownloadClick}
        onDownloadCancel={() => {this.setState({downloadMode: false})}}
        bankAccountNumber={this.props.match.params.bankAccountId}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getBankAccounts(context)
    this.getTransactions(context)
  }

  componentDidUpdate(prevProps) {
    if (prevProps.match.params.bankAccountId == this.props.match.params.bankAccountId)
      return

    let context = this.props.context
    this.getTransactions(context)
  }

  getBankAccounts(context) {
    let cacheManager = new CacheManager({
      resource: `/api/accounts/${context.session.accountId}/bankAccounts`,
      cacheKey: CacheKeys.BankAccounts(context.session.accountId),
      callback: this.getBankAccountsCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getBankAccountsCallback = (response) => {
    this.setState({
      bankAccountList: response.bankAccountList,
      errorList: response.errorList
    })
  }

  getTransactions(context) {
    if (!context.permissions) { // session expired for some reason
      localStorage.removeItem(LocalStorageKeys.Session)
      localStorage.removeItem(LocalStorageKeys.Session + ':CachedTime')
      setTimeout(() => {
        window.location = '/pub/message?key=invalid_session'
      }, 600)
      return
    }

    let cacheManager = new CacheManager({
      resource: `/api/accounts/${context.session.accountId}/bankAccounts/${this.props.match.params.bankAccountId}/transactionsZybra`,
      cacheKey: CacheKeys.Transactions(context.session.accountId, this.props.match.params.bankAccountId),
      callback: this.getTransactionsCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getTransactionsCallback = (response) => {
    let filtersStr = sessionStorage.getItem(CacheKeys.TransactionsFilter(this.props.context.session.accountId, this.props.match.params.bankAccountId))
    let filters = filtersStr ? JSON.parse(filtersStr) : {}

    this.setState({
      errorList: response.errorList,
      txnList: response.transactionList,
      filteredTxnList: response.transactionList,
      searchFilter: filters.searchFilter ? filters.searchFilter : '',
      currentPage: response.currentPage,
      hasMore: response.hasMore
    })

    this.applyFilters(response.transactionList, filters.searchFilter ? filters.searchFilter : '')
  }

  onMoreTransactions = () => {
    let context = this.props.context
    this.setState({gettingMore: true})

    RestApiUtils.get(
      this.props.context,
      `/api/accounts/${context.session.accountId}/bankAccounts/${this.props.match.params.bankAccountId}/transactions`,
      this.onMoreTransactionsCallback,
      null,
      {requestedPage: this.state.currentPage + 1}
    )
  }

  onMoreTransactionsCallback = (response) => {
    let context = this.props.context
    let txnList = this.state.txnList
    response.transactionList = txnList.concat(response.transactionList)

    let filtersStr = sessionStorage.getItem(CacheKeys.TransactionsFilter(this.props.context.session.accountId, this.props.match.params.bankAccountId))
    let filters = filtersStr ? JSON.parse(filtersStr) : {}

    this.setState({
      errorList: response.errorList,
      txnList: response.transactionList,
      filteredTxnList: response.transactionList,
      searchFilter: filters.searchFilter ? filters.searchFilter : '',
      currentPage: response.currentPage,
      hasMore: response.hasMore,
      gettingMore: false
    })

    CacheManager.setObject(CacheKeys.Transactions(context.session.accountId, this.props.match.params.bankAccountId), response)

    this.applyFilters(response.transactionList, filters.searchFilter ? filters.searchFilter : '')
  }

  applyFilters(txnList, searchFilter) {
    let filteredList = txnList

    if (searchFilter)
      filteredList = filteredList.filter(txn => txn.payee &&
        txn.payee.toLocaleLowerCase().includes(searchFilter.toLocaleLowerCase())
      )

    this.setState({filteredTxnList: filteredList})

    let filters = {
      searchFilter: searchFilter,
    }
    sessionStorage.setItem(CacheKeys.TransactionsFilter(this.props.context.session.accountId, this.props.match.params.bankAccountId), JSON.stringify(filters))
  }

  onDownloadClick = () => {
    this.setState({downloadMode: true})
  }

  onRefreshClick = () => {
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.Transactions(context.session.accountId, this.props.match.params.bankAccountId))
    this.setState({
      errorList: null,
      txnList: null,
      filteredTxnList: null,
    }, () => {
      this.getTransactions(context)
    })
  }

  onSearchFilterChange = (event) => {
    let searchFilter = event.target.value
    this.setState({searchFilter: searchFilter})
    this.applyFilters(this.state.txnList, searchFilter)
  }
}

export default withRouter(ZTransactionListPageSF)
